export const CHEAT_COMMANDS = {
	captainUp: {
		setActiveDockWidget: "cheats.captainup.setActiveDockWidget",
		setTooltipPosition: "cheats.captainup.setTooltipPosition",
		openPopup: "cheats.captainup.openPopup",
		closePopup: "cheats.captainup.closePopup",
		retryBoot: "cheats.captainup.retryBoot",
	},
	ef: {
		setWidgetPosition: "cheats.ef.setWidgetPosition",
		sendHeartBeat: "cheats.ef.sendHeartBeat",
		sendFatalError: "cheats.ef.sendFatalError",
		sendClientReady: "cheats.ef.sendClientReady",
		sendBetUpdated: "cheats.ef.sendBetUpdated",
		triggerCaptainUpAuthTimeout: "cheats.ef.triggerCaptainUpAuthTimeout",
		triggerCaptainUpAuthBadRequest: "cheats.ef.triggerCaptainUpAuthBadRequest",
		triggerCaptainUpAuthNotFound: "cheats.ef.triggerCaptainUpAuthNotFound",
		triggerCaptainUpAuthServerError: "cheats.ef.triggerCaptainUpAuthServerError",
		triggerCaptainUpSdkLoadFailure: "cheats.ef.triggerCaptainUpSdkLoadFailure",
		triggerCaptainUpSdkInitFailure: "cheats.ef.triggerCaptainUpSdkInitFailure",
		triggerAllHitAreaWidgetSnapshots: "cheats.ef.triggerAllHitAreaWidgetSnapshots",
	},
} as const;

export type CaptainUpCheatCommandName =
	(typeof CHEAT_COMMANDS)["captainUp"][keyof (typeof CHEAT_COMMANDS)["captainUp"]];

export type EFProtocolCheatCommandName =
	(typeof CHEAT_COMMANDS)["ef"][keyof (typeof CHEAT_COMMANDS)["ef"]];
